import React from 'react';
import { Accordion, AccordionSummary, AccordionDetails, Typography, TextField } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ShowStats from './ShowStats';

const OutputItems = (props) => {
	const { data } = props;
	const rows = data.stats;
	const cteSqlList = data.cteSqlList;
	const sequenceSqlList = data.sequenceSqlList; // === undefined ? "" : data.sequenceSqlList;
	const targetSqlList = data.targetSqlList; // === undefined ? "" : data.targetSqlList;
	const hasProperAuth = !data.needProperAuth;
	const needsCorporateLogin = data.needsCorporateLogin;
	const preamble = data.preamble;
	// console.log("needsCorporateLogin="+needsCorporateLogin);
	console.log(data);

	return (
		<div>
			<p />
			{rows && rows.length > 0 &&
				//((models && models.length > 0) || (mapplets && mapplets.length > 0)) &&
				<Accordion>
					<AccordionSummary expandIcon={<ExpandMoreIcon />}
						id="stats-accordion">
						{
							hasProperAuth ?
								<Typography sx={{ width: '20%', flexShrink: 0, color: 'green', fontSize: 12 }}>Stats</Typography>
								:
								<Typography sx={{ width: '20%', flexShrink: 0, color: 'blue', fontSize: 12 }}>Stats</Typography>
						}
						<Typography sx={{ color: 'lightblue', fontSize: 12 }}>Check out the time you saved and other interesting findings</Typography>
					</AccordionSummary>
					<AccordionDetails>
						<ShowStats data={data} />
					</AccordionDetails>
				</Accordion>
			}
			{
				!needsCorporateLogin && hasProperAuth && sequenceSqlList && sequenceSqlList.length > 0 &&
				<Accordion>
					<AccordionSummary expandIcon={<ExpandMoreIcon />}
						id="sql-sequence-accordion">
						<Typography sx={{ width: '20%', flexShrink: 0, color: 'green', fontSize: 12 }}>Sequences</Typography>
						<Typography sx={{ color: 'lightblue', fontSize: 12 }}>These are the sequences your CTEs need</Typography>
					</AccordionSummary>
					<AccordionDetails>
					<TextField id='seqSql'
						multiline
						fullWidth
						inputProps={{ style: { fontSize: 10 } }}
						sx={{ backgroundColor: 'lightblue' }}
						margin='normal'
						color='success'
						maxRows={8}
						value={preamble+"\n"+sequenceSqlList.join("\n")} />
					</AccordionDetails>
				</Accordion>
			}
			{ !needsCorporateLogin && hasProperAuth && cteSqlList && cteSqlList.length > 0 &&
				<Accordion>
				<AccordionSummary expandIcon={<ExpandMoreIcon />}
						id="sql-cte-accordion">
						<Typography sx={{ width: '20%', flexShrink: 0, color: 'green', fontSize: 12 }}>CTE</Typography>
					<Typography sx={{ color: 'lightblue', fontSize: 12 }}>Core Common Table Expressions for your solution ({ cteSqlList.length })</Typography>
					</AccordionSummary>
					<AccordionDetails>
						<TextField id='cteSql'
							multiline
							fullWidth
							inputProps={{ style: { fontSize: 10 } }}
							sx={{ backgroundColor: 'lightblue' }}
							margin='normal'
							color='success'
							maxRows={20}
						value={preamble+"\n"+cteSqlList.join("\n")} />
					</AccordionDetails>
				</Accordion>
			}
			{
				!needsCorporateLogin && hasProperAuth && targetSqlList && targetSqlList.length > 0 &&
				<Accordion>
					<AccordionSummary expandIcon={<ExpandMoreIcon />}
						id="sql-target-accordion">
						<Typography sx={{ width: '20%', flexShrink: 0, color: 'green', fontSize: 12 }}>Target SQLs</Typography>
						<Typography sx={{ color: 'lightblue', fontSize: 12 }}>DML statements derived from the above CTEs ({targetSqlList.length})</Typography>
					</AccordionSummary>
					<AccordionDetails>
						<TextField id='tgtSql'
							multiline
							fullWidth
							inputProps={{ style: { fontSize: 10 } }}
							sx={{ backgroundColor: 'lightblue' }}
							margin='normal'
							color='success'
							maxRows={8}
							value={preamble+"\n"+targetSqlList.join("\n")} />
					</AccordionDetails>
				</Accordion >
			}
			{
				/* https://codesandbox.io/s/mui-accordion-menu-forked-t725z?file=/src/App.tsx */
			}
		</div>
	);
};

export default OutputItems;